import './SuggestionsOverlay.css';
import './Suggestion.css';
export var suggestion = '_1fgztdc0-2-0-1';
export var suggestionText = '_1fgztdc2-2-0-1';
export var suggestionWithIcon = '_1fgztdc1-2-0-1';
export var suggestionsEmptyState = '_1fgztdc3-2-0-1';
export var suggestionsLoading = '_1fgztdc4-2-0-1';